<div class="where-wrapper" (outsideClick)="setFocus(false)">
  <!-- Search Input Section -->
  <div class="search-input-container">
    <div class="search-icon">
      <svg-icon 
        [svgStyle]="{'width.px': 20, 'height.px': 20}" 
        src="/assets/icons/magnifying-glass-grey.svg">
      </svg-icon>
    </div>
    <div class="search-input-wrapper">
      <input 
        #whereInput 
        class="search-input" 
        type="text"
        [value]="displayValue" 
        [placeholder]="(focused | async) ? '' : placeholderText" 
        (focus)="setFocus(true)"
        (input)="onInputChange($event)"
        (keyup)="onInputChange($event)">
    </div>
  </div>

  <!-- Search Results Dropdown -->
  <ng-container *ngIf="shouldShowResults">
    <div class="search-dropdown" (outsideClick)="setFocus(false)">
      <div class="search-dropdown-content">
        <!-- Loading State -->
        <div class="search-state" *ngIf="(searching | async)">
          <div class="search-state-message">Searching places...</div>
        </div>

        <!-- No Results State -->
        <div class="search-state" *ngIf="!(searching | async) && (places | async) !== undefined && (places | async)?.length === 0">
          <div class="search-state-message">No results found</div>
        </div>

        <!-- Results List -->
        <div class="search-results-list" *ngIf="!(searching | async) && (places | async) && (places | async)?.length > 0">
          <div 
            *ngFor="let place of places | async; trackBy: trackByCity" 
            class="search-result-item"
            (click)="doUpdate(place)">
            
            <!-- Place Result (Cities, Countries, States) -->
            <app-place 
              *ngIf="place.searchType === 1 || place.searchType === 4 || place.searchType === 5"
              [place]="place" 
              [query]="whereInput.value">
            </app-place>
            
            <!-- Hostel Result -->
            <app-hostel 
              *ngIf="place.searchType === 2"
              [hostel]="place" 
              [query]="whereInput.value">
            </app-hostel>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
